<template>
    <div class="is-marginless" @click.stop>
        <app-search-bar
            :placeholder="$t('search_text')"
            :filter.sync="typeFilter"
            :text.sync="searchValue"
            class="mx-4 my-4 object-list-search"
            @input="searchObjects"
        />
        <div class="lb-separator" />
        <div class="object-list-zone">
            <div v-for="item in items" :key="item._id">
                <article
                    class="py-3 pl-4 pr-2 object-element"
                    @click="centerMap(item)"
                >
                <div class="columns is-mobile is-vcentered">
                    <div class="column is-narrow pr-0">
                            <figure class="media-left">
                            <img :src="getObjectTypeIcon(item)" width="32px"/>
                        </figure>
                    </div>
                    <div class="column px-0">
                        <div>
                        <!--<p class="object-tile is-size-6 mb-0 is-clipped-1" :title="item.title">
                            {{ item.title }}
                        </p>-->
                        <p class="object-tile is-size-6 mb-0 is-clipped-1" :title="getName(item)">
                            {{ getName(item) }}
                        </p>
                        <p class="is-clipped is-size-7 has-text-primary">{{ getOwner(item) }}</p>

                        </div>
                    </div>
                    <div class="column is-narrow pr-5">
                        <span class="icon py-4 px-0">
                                <i class="mdi mdi-48px mdi-chevron-right has-text-primary"></i>
                            </span>
                    </div>
                </div>
                </article>
                <!--<article
                    class="media py-3 pl-4 pr-2 object-element"
                    @click="centerMap(item)"
                >
                    <figure class="media-left">
                        <img :src="getObjectTypeIcon(item)" width="32px"/>
                    </figure>
                    <div class="media-content">
                        <div class="content">
                            <div class="columns is-mobile is-vcentered">
                                <div class="column is-narrow">
                                     <figure class="media-left">
                                        <img :src="getObjectTypeIcon(item)" width="32px"/>
                                    </figure>
                                </div>
                                <div class="column">
                                    <div>
                                    <p class="object-tile is-size-6 mb-0">
                                        {{ item.title }}
                                    </p>
                                    <p class="is-clipped is-size-7 has-text-primary">{{ getOwner(item) }}</p>

                                    </div>
                                </div>
                                <div class="column is-narrow">
                                    <span class="icon py-4 px-0">
                                            <i class="mdi mdi-48px mdi-chevron-right has-text-primary"></i>
                                        </span>
                                </div>
                            </div>
                            <nav class="level is-mobile mb-0">
                                <div class="level-left">
                                    <div class="level-item">
                                        <div>
                                            <p class="object-tile is-size-6 mb-0">
                                                {{ item.title }}
                                            </p>
                                            <p class="is-clipped is-size-7 has-text-primary">{{ getOwner(item) }}</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="level-right">
                                    <div class="level-item">
                                       <span class="icon py-4 px-0">
                                            <i class="mdi mdi-48px mdi-chevron-right has-text-primary"></i>
                                        </span>
                                    </div>
                                </div>
                            </nav>
                            
                        </div>
                    </div>
                    <div class="media-right"></div>
                </article>-->
                <div class="lb-separator" />
            </div>
        </div>
        <div class="action-buttons-container mb-2">
            <a @click="$emit('toggleObjectList')" class="button is-primary">
                <span class="icon is-small my-2"
                    ><i
                        class="mdi mdi-32px mdi-chevron-double-left"
                        aria-hidden="true"
                    ></i
                ></span>
            </a>
           
        </div>
    </div>
</template>

<script>
import _ from 'underscore';
import AppSearchBar from '@/components/AppSearchBar';
export default {
    components: {
        AppSearchBar,
    },
    props: {
        items: { type: Array, default: [] },
    },
    data() {
        return {
            slideUp: false,
            slideDown: true,
            typeFilter: this.$t('Constants.FILTER_OPTION_ALL'),
            searchValue: '',
        };
    },
    filters: {
        strippedContent: function (string) {
            const div = document.createElement('div');
            div.innerHTML = string;
            const text = div.textContent || div.innerText || '';
            return text;
        },
    },
    computed: {
        user() {
            return this.$store.getters.user;
        }
    },
    watch: {},
    mounted() {},
    methods: {
        centerMap(item) {
            this.$emit('centerMap', item);
            // console.log(this.$refs);
        },
        getObjectTypeIcon(object) {
            // console.log(object.type);
            if (object.type == 'question') {
                return '/img/map-icons/00_question.svg';
            } else {
                return '/img/map-icons/00_point.svg';
            }
        },
        searchObjects(text) {
            this.searchValue = text;
            this.$emit('searchObjects',text)
            //this.filteredItems;
        },
        getOwner(item) {
            if (item.accessLevel && item.accessLevel == 'administrator') {
                return item.owner.name + " " + item.owner.surname;
            } else {
                return " ";
            }
            /*if (item.owner && item.owner.school) {
                if (item.owner.school.name) {
                    // console.log()
                    return item.owner.school.name
                }
                
            }

            if(item.owner && item.owner.alias){
                return item.owner.alias
            }else if(item.owner && item.owner.name){
                return item.owner.name
            }else{
                return this.$t('anonymous_username');
            }*/
            
        },
        getName(item) {
            const defaultLang = this.$store.getters.project.defaultLang;
            // console.log("locale", locale)
            if (defaultLang && item.titlePerLang && item.titlePerLang[defaultLang]) {
                // console.log("returning default")
                return item.titlePerLang[defaultLang]
            } else {
                // console.log("returning standar")
                return item.title;
            }
        },
    },
};
</script>

<style scoped>
@import '../assets/css/object-list.css';

</style>
